import { TableContainer, ITableStructure } from '../../../base';
import { TableIds } from '../../../common';
import { useTableFilters } from './hooks/useTableFilters';
import { useTableCells } from './hooks/useTableCells';
import { useTableCallbacks } from './hooks/useTableCallbacks';
import { useTableToggles } from './hooks/useTableToggles';

const JobsTable = () => {
    const cells = useTableCells();
    const filters = useTableFilters();
    const toggles = useTableToggles();
    const { onRowClick, onMenuItemClick } = useTableCallbacks();

    const callbacks = {
        onRowClick,
        onMenuItemClick,
    };

    const tableStructure: ITableStructure = {
        id: TableIds.JOBS,
        cells,
        filters,
        toggles,
        rowSelection: true,
    };

    return <TableContainer structure={tableStructure} callbacks={callbacks} />;
};
export default JobsTable;
